var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isWeixin)?_c('wx-open-launch-app',{attrs:{"appid":_vm.config.appAppId,"extinfo":_vm.extinfo},on:{"error":_vm.error,"launch":_vm.launch}},[_vm._t("weixin")],2):_c('div',[_vm._t("unWeixin")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }